import { render, staticRenderFns } from "./DadosColunasComponent.vue?vue&type=template&id=0433726a"
import script from "./DadosColunasComponent.vue?vue&type=script&lang=js"
export * from "./DadosColunasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports